"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "className", "disabled", "isOverflowing"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTypography = (0, _material.styled)(_Typography.Typography)(function () {
  return {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});

var Protraction = function Protraction(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _ref$isOverflowing = _ref.isOverflowing,
      isOverflowing = _ref$isOverflowing === void 0 ? function (el) {
    return el.clientWidth < el.scrollWidth;
  } : _ref$isOverflowing,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      shouldShowTooltip = _useState4[0],
      setShouldShowTooltip = _useState4[1];

  var contentRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(function () {
    if (!contentRef.current || disabled) return;

    if (typeof isOverflowing === "function") {
      setShouldShowTooltip(isOverflowing(contentRef.current));
    } else {
      setShouldShowTooltip(isOverflowing);
    }
  }, [isOverflowing, setShouldShowTooltip, disabled]);

  var onOpen = function onOpen() {
    if (!shouldShowTooltip) return;
    setOpen(true);
  };

  var onClose = function onClose() {
    setOpen(false);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
    componentsProps: {
      tooltip: {
        sx: {
          background: function background(theme) {
            return theme.palette.brand.grey.grey;
          },
          fontSize: "0.75rem",
          fontWeight: "bold",
          maxWidth: "15rem",
          padding: function padding(theme) {
            return "".concat(theme.spacing(2), " ").concat(theme.spacing(3));
          }
        }
      }
    },
    disableFocusListener: disabled,
    disableHoverListener: disabled,
    disableInteractive: disabled,
    disableTouchListener: disabled,
    onClose: onClose,
    onOpen: onOpen,
    open: open,
    title: children,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, _objectSpread(_objectSpread({
      className: className,
      ref: contentRef,
      tabIndex: shouldShowTooltip ? 0 : undefined
    }, rest), {}, {
      children: children
    }))
  });
};

var _default = Protraction;
exports.default = _default;